import { gql } from '@apollo/client';

export const OBTENER_ESTADO_GEOPOSICION = gql`
    query ObtenerEstadoGeoposicion {
        obtenerEstadoGeoposicion {
            estaEjecutando
            fechaInicio
            fechaFin
            totalRegistros
            totalProcesados
            exitosos
            fallidos
            progreso
            tiempoTranscurrido
        }
    }
`;